module.exports = __webpack_public_path__ + "img/operate_btn_3.96bcc43e.png";